<template>
  <div>

    <!-- Current risk modal -->
    <b-modal ref="current-risk" hide-footer @hide="hideCurrentRiskModal" size="xl">
      <div class="d-block text-center">
        <h4 qid="current-risk-modal-title">
          {{ $t('activities.risk_scenario.current_risk.title') }}
        </h4>
      </div>
      <div class="mt-2 mb-2">
        <div v-if="riskScenarioItem && riskScenarioItem.risk_scenario">
          <font-awesome-icon icon="theater-masks" size="lg" /> {{ riskScenarioItem.risk_scenario.name }}
        </div>
        <div v-if="riskScenarioItem && riskScenarioItem.activity" class="mt-3">
          <font-awesome-icon icon="cubes" size="lg" /> {{ riskScenarioItem.activity.name }}
          <div class="mt-3" v-if="riskScenarioItem.activity.active_client.slug != getClient.slug && !getClient.parent">
            <font-awesome-icon icon="layer-group" size="lg" /> {{ riskScenarioItem.activity.active_client.name }}
          </div>
        </div>
        <div v-if="riskScenarioItem && riskScenarioItem.process" class="mt-3">
          <font-awesome-icon icon="cube" size="lg" /> {{ riskScenarioItem.process.name }}
          <div class="mt-3" v-if="riskScenarioItem.process.active_client.slug != getClient.slug && !getClient.parent">
            <font-awesome-icon icon="layer-group" size="lg" /> {{ riskScenarioItem.process.active_client.name }}
          </div>
        </div>
        <div v-if="riskScenarioItem && riskScenarioItem.system" class="mt-3">
          <font-awesome-icon icon="desktop" size="lg" /> {{ riskScenarioItem.system.name }}
          <div class="mt-3" v-if="riskScenarioItem.system.active_client.slug != getClient.slug && !getClient.parent">
            <font-awesome-icon icon="layer-group" size="lg" /> {{ riskScenarioItem.system.active_client.name }}
          </div>
        </div>
        <div v-if="riskScenarioItem && riskScenarioItem.third_party" class="mt-3">
          <font-awesome-icon icon="file-signature" size="lg" /> {{ riskScenarioItem.third_party.name }}
          <div class="mt-3" v-if="riskScenarioItem.third_party.active_client.slug != getClient.slug && !getClient.parent">
            <font-awesome-icon icon="layer-group" size="lg" /> {{ riskScenarioItem.third_party.active_client.name }}
          </div>
        </div>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="current-risk-modal-error"
      >
        {{ error }}
      </b-alert>

      <div class="row mt-5">
        <div :class="{'col-sm-6': hasType('privacy_risk'), 'col-sm-12': !hasType('privacy_risk')}" v-if="hasType('business_risk')">
          <div class="mb-2" v-if="getClient.risk_type != 'cia_risk'">
            <span v-if="riskScenarioItem && riskScenarioItem.business_inherent_risk" class="mr-3">
              <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>:
              <span v-if="!riskScenarioItem.business_inherent_risk.risk">{{ $t('system.n_a') }}</span>
              <span :qid="'risk-risk-' + riskScenarioItem.business_inherent_risk.risk" v-if="riskScenarioItem.business_inherent_risk.risk">
                <font-awesome-icon
                  icon="exclamation-triangle"
                  v-if="riskScenarioItem.business_inherent_risk.number"
                  :class="[ riskScenarioItem.business_inherent_risk.number ? 'risk-'+riskScenarioItem.business_inherent_risk.number : 'risk' ]"
                />
                <span v-if="riskScenarioItem.business_inherent_risk.risk">
                  {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_inherent_risk.risk)) }}
                </span>
                <span v-if="riskScenarioItem.business_inherent_risk.number">
                  ({{riskScenarioItem.business_inherent_risk.number}})
                </span>
                &nbsp;
              </span>
            </span>
            <span class="mr-3">
              <span>{{ $t('activities.risk_scenario.inherent_risk.risk_tolerance_label') }}</span>:
              <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.business_risk_tolerance.risk)">{{ $t('system.n_a') }}</span>
              <span v-if="object.risk_category && object.risk_category.business_risk_tolerance.risk">
                <font-awesome-icon
                  icon="exclamation-triangle"
                  v-if="object.risk_category.business_risk_tolerance.number"
                  :class="[ object.risk_category.business_risk_tolerance.number ? 'risk-'+object.risk_category.business_risk_tolerance.number : 'risk' ]"
                />
                <span v-if="object.risk_category.business_risk_tolerance.risk">
                  {{ $t('risk.' + $options.filters.slugify(object.risk_category.business_risk_tolerance.risk)) }}
                </span>
                <span v-if="object.risk_category.business_risk_tolerance.number">
                  ({{object.risk_category.business_risk_tolerance.number}})
                </span>
                &nbsp;
              </span>
            </span>
          </div>
          <div class="mb-2 row" v-if="getClient.risk_type == 'cia_risk'">
            <div class="col-sm-6">
              <div>
                <div class="mb-2">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>:
                </div>
                <div>
                  <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                  <span v-if="!riskScenarioItem.business_confidentiality_inherent_risk.risk">{{ $t('system.n_a') }}</span>
                  <span :qid="'risk-risk-' + riskScenarioItem.business_confidentiality_inherent_risk.risk" v-if="riskScenarioItem.business_confidentiality_inherent_risk.risk">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      v-if="riskScenarioItem.business_confidentiality_inherent_risk.number"
                      :class="[ riskScenarioItem.business_confidentiality_inherent_risk.number ? 'risk-'+riskScenarioItem.business_confidentiality_inherent_risk.number : 'risk' ]"
                    />
                    <span v-if="riskScenarioItem.business_confidentiality_inherent_risk.risk">
                      {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_confidentiality_inherent_risk.risk)) }}
                    </span>
                    <span v-if="riskScenarioItem.business_confidentiality_inherent_risk.number">
                      ({{riskScenarioItem.business_confidentiality_inherent_risk.number}})
                    </span>
                    &nbsp;
                  </span>
                </div>
                <div>
                  <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                  <span v-if="!riskScenarioItem.business_integrity_inherent_risk.risk">{{ $t('system.n_a') }}</span>
                  <span :qid="'risk-risk-' + riskScenarioItem.business_integrity_inherent_risk.risk" v-if="riskScenarioItem.business_integrity_inherent_risk.risk">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      v-if="riskScenarioItem.business_integrity_inherent_risk.number"
                      :class="[ riskScenarioItem.business_integrity_inherent_risk.number ? 'risk-'+riskScenarioItem.business_integrity_inherent_risk.number : 'risk' ]"
                    />
                    <span v-if="riskScenarioItem.business_integrity_inherent_risk.risk">
                      {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_integrity_inherent_risk.risk)) }}
                    </span>
                    <span v-if="riskScenarioItem.business_integrity_inherent_risk.number">
                      ({{riskScenarioItem.business_integrity_inherent_risk.number}})
                    </span>
                    &nbsp;
                  </span>
                </div>
                <div>
                  <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                  <span v-if="!riskScenarioItem.business_availability_inherent_risk.risk">{{ $t('system.n_a') }}</span>
                  <span :qid="'risk-risk-' + riskScenarioItem.business_availability_inherent_risk.risk" v-if="riskScenarioItem.business_availability_inherent_risk.risk">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      v-if="riskScenarioItem.business_availability_inherent_risk.number"
                      :class="[ riskScenarioItem.business_availability_inherent_risk.number ? 'risk-'+riskScenarioItem.business_availability_inherent_risk.number : 'risk' ]"
                    />
                    <span v-if="riskScenarioItem.business_availability_inherent_risk.risk">
                      {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.business_availability_inherent_risk.risk)) }}
                    </span>
                    <span v-if="riskScenarioItem.business_availability_inherent_risk.number">
                      ({{riskScenarioItem.business_availability_inherent_risk.number}})
                    </span>
                    &nbsp;
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-2">
                <span>{{ $t('activities.risk_scenario.inherent_risk.risk_tolerance_label') }}</span>:
              </div>
              <div>
                <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.business_risk_confidentiality.risk)">{{ $t('system.n_a') }}</span>
                <span v-if="object.risk_category && object.risk_category.business_risk_confidentiality.risk">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                    v-if="object.risk_category.business_risk_confidentiality.number"
                    :class="[ object.risk_category.business_risk_confidentiality.number ? 'risk-'+object.risk_category.business_risk_confidentiality.number : 'risk' ]"
                  />
                  <span v-if="object.risk_category.business_risk_confidentiality.risk">
                    {{ $t('risk.' + $options.filters.slugify(object.risk_category.business_risk_confidentiality.risk)) }}
                  </span>
                  <span v-if="object.risk_category.business_risk_confidentiality.number">
                    ({{object.risk_category.business_risk_confidentiality.number}})
                  </span>
                  &nbsp;
                </span>
              </div>
              <div>
                <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.business_risk_integrity.risk)">{{ $t('system.n_a') }}</span>
                <span v-if="object.risk_category && object.risk_category.business_risk_integrity.risk">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                    v-if="object.risk_category.business_risk_integrity.number"
                    :class="[ object.risk_category.business_risk_integrity.number ? 'risk-'+object.risk_category.business_risk_integrity.number : 'risk' ]"
                  />
                  <span v-if="object.risk_category.business_risk_integrity.risk">
                    {{ $t('risk.' + $options.filters.slugify(object.risk_category.business_risk_integrity.risk)) }}
                  </span>
                  <span v-if="object.risk_category.business_risk_integrity.number">
                    ({{object.risk_category.business_risk_integrity.number}})
                  </span>
                  &nbsp;
                </span>
              </div>
              <div>
                <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.business_risk_availability.risk)">{{ $t('system.n_a') }}</span>
                <span v-if="object.risk_category && object.risk_category.business_risk_availability.risk">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                    v-if="object.risk_category.business_risk_availability.number"
                    :class="[ object.risk_category.business_risk_availability.number ? 'risk-'+object.risk_category.business_risk_availability.number : 'risk' ]"
                  />
                  <span v-if="object.risk_category.business_risk_availability.risk">
                    {{ $t('risk.' + $options.filters.slugify(object.risk_category.business_risk_availability.risk)) }}
                  </span>
                  <span v-if="object.risk_category.business_risk_availability.number">
                    ({{object.risk_category.business_risk_availability.number}})
                  </span>
                  &nbsp;
                </span>
              </div>
            </div>
          </div>
          <div class="form-control auto-height">
            <button class="btn btn-success btn-sm mt-3 float-right"
                    qid="add-business-button"
                    v-if="
                      (
                        (riskScenarioItem.activity && riskScenarioItem.activity.active_client.slug == getClient.slug) ||
                        (riskScenarioItem.process && riskScenarioItem.process.active_client.slug == getClient.slug) ||
                        (riskScenarioItem.system && riskScenarioItem.system.active_client.slug == getClient.slug) ||
                        (riskScenarioItem.third_party && riskScenarioItem.third_party.active_client.slug == getClient.slug)
                      ) &&
                      (
                        (
                          (riskScenarioItem && riskScenarioItem.activity && isGranted([permissions.ACTIVITY_EDIT, permissions.ACTIVITY_EDIT_OWN], riskScenarioItem.activity)) ||
                          (riskScenarioItem && riskScenarioItem.process && isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], riskScenarioItem.process)) ||
                          (riskScenarioItem && riskScenarioItem.system && isGranted([permissions.SYSTEM_EDIT, permissions.PROCESS_EDIT_OWN], riskScenarioItem.system)) ||
                          (riskScenarioItem && riskScenarioItem.third_party && isGranted([permissions.THIRD_PARTY_EDIT, permissions.THIRD_PARTY_EDIT_OWN], riskScenarioItem.third_party))
                        ) ||
                        isGranted([permissions.RISK_SCENARIO_EDIT, permissions.RISK_SCENARIO_EDIT_OWN], riskScenarioItem.risk_scenario)
                      )
                    "
                    @click="showBusinessRiskModal()"
            >
              <font-awesome-icon icon="plus"/> {{ $t('activities.risk_scenario.current_risk.new_business_risk_button') }}
            </button>
            <h5 class="mt-3">{{ $t('activities.risk_scenario.inherent_risk.business_risk') }}</h5>
            <table class="table table-responsive-md table-sm">
              <thead>
              <tr>
                <th scope="col">
                  {{ $t('maintenance.risk_categories.risk.risk_label') }}
                </th>
                <th scope="col">
                  {{ $t('activities.risk_scenario.inherent_risk.risk_response_label') }}
                </th>
                <th scope="col">
                  {{ $t('system.last_updated') }}
                </th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in businessRisks"
                    v-if="index == 0"
                    class="text-bold"
                >
                  <td v-if="item">
                    <div v-if="getClient.risk_type == 'cia_risk'" @click="showViewRiskModal(item)">
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                        <span :qid="'risk-risk-' + item.confidentiality_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.confidentiality_risk.number"
                              :class="[ item.confidentiality_risk.number ? 'risk-'+item.confidentiality_risk.number : 'risk' ]"
                          />
                          <span v-if="item.confidentiality_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.confidentiality_risk.risk)) }}
                          </span>
                          <span v-if="item.confidentiality_risk.number">
                            ({{item.confidentiality_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                        <span :qid="'risk-risk-' + item.integrity_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.integrity_risk.number"
                              :class="[ item.integrity_risk.number ? 'risk-'+item.integrity_risk.number : 'risk' ]"
                          />
                          <span v-if="item.integrity_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.integrity_risk.risk)) }}
                          </span>
                          <span v-if="item.integrity_risk.number">
                            ({{item.integrity_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                        <span :qid="'risk-risk-' + item.availability_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.availability_risk.number"
                              :class="[ item.availability_risk.number ? 'risk-'+item.availability_risk.number : 'risk' ]"
                          />
                          <span v-if="item.availability_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.availability_risk.risk)) }}
                          </span>
                          <span v-if="item.availability_risk.number">
                            ({{item.availability_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                    </div>
                    <span :qid="'risk-risk-' + item.risk.risk"
                          @click="showViewRiskModal(item)"
                          class="cursor-pointer"
                          v-if="getClient.risk_type != 'cia_risk'"
                    >
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="item.risk.number"
                          :class="[ item.risk.number ? 'risk-'+item.risk.number : 'risk' ]"
                      />
                      <span v-if="item.risk.risk">
                        {{ $t('risk.' + $options.filters.slugify(item.risk.risk)) }}
                      </span>
                      <span v-if="item.risk.number">
                        ({{item.risk.number}})
                      </span>
                      &nbsp;
                    </span>
                  </td>
                  <td v-if="item">
                    <span v-if="item.risk_response">
                      {{ $t('risk_response.' + $options.filters.slugify(item.risk_response)) }}
                    </span>
                  </td>
                  <td v-if="item">
                    <span>
                      <Avatar :object="item.updated_by" size="xs" class="mr-2" v-if="item.updated_by"></Avatar>
                      {{ item.created_at | formatDate }}
                    </span>
                  </td>
                </tr>
                <tr class="text-center" v-if="businessRisks && businessRisks.length && businessRisks.length > 1">
                  <td colspan="6" class="text-center cursor-pointer" @click="businessHistoryShow=!businessHistoryShow">
                    <span class="mr-2">{{ $t('activities.risk_scenario.view_history_log') }}</span>
                    <font-awesome-icon icon="chevron-down" v-if="!businessHistoryShow"/>
                    <font-awesome-icon icon="chevron-up" v-if="businessHistoryShow"/>
                  </td>
                </tr>
                <tr v-for="(item, index) in businessRisks"
                    v-if="index >= 1 && businessHistoryShow"
                    class="text-bold"
                >
                  <td v-if="item">
                    <div v-if="getClient.risk_type == 'cia_risk'" @click="showViewRiskModal(item)">
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                        <span :qid="'risk-risk-' + item.confidentiality_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.confidentiality_risk.number"
                              :class="[ item.confidentiality_risk.number ? 'risk-'+item.confidentiality_risk.number : 'risk' ]"
                          />
                          <span v-if="item.confidentiality_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.confidentiality_risk.risk)) }}
                          </span>
                          <span v-if="item.confidentiality_risk.number">
                            ({{item.confidentiality_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                        <span :qid="'risk-risk-' + item.integrity_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.integrity_risk.number"
                              :class="[ item.integrity_risk.number ? 'risk-'+item.integrity_risk.number : 'risk' ]"
                          />
                          <span v-if="item.integrity_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.integrity_risk.risk)) }}
                          </span>
                          <span v-if="item.integrity_risk.number">
                            ({{item.integrity_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                        <span :qid="'risk-risk-' + item.availability_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.availability_risk.number"
                              :class="[ item.availability_risk.number ? 'risk-'+item.availability_risk.number : 'risk' ]"
                          />
                          <span v-if="item.availability_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.availability_risk.risk)) }}
                          </span>
                          <span v-if="item.availability_risk.number">
                            ({{item.availability_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                    </div>
                    <span :qid="'risk-risk-' + item.risk.risk"
                          @click="showViewRiskModal(item)"
                          class="cursor-pointer"
                          v-if="getClient.risk_type != 'cia_risk'"
                    >
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="item.risk.number"
                          :class="[ item.risk.number ? 'risk-'+item.risk.number : 'risk' ]"
                      />
                      <span v-if="item.risk.risk">
                        {{ $t('risk.' + $options.filters.slugify(item.risk.risk)) }}
                      </span>
                      <span v-if="item.risk.number">
                        ({{item.risk.number}})
                      </span>
                      &nbsp;
                    </span>
                  </td>
                  <td v-if="item">
                    <span v-if="item.risk_response">
                      {{ $t('risk_response.' + $options.filters.slugify(item.risk_response)) }}
                    </span>
                  </td>
                  <td v-if="item">
                    <button class="text-muted float-right ml-2 btn btn-link btn-sm"
                            qid="activity-risk-scenario-delete-modal"
                            v-if="isGranted([permissions.RISK_SCENARIO_EDIT, permissions.RISK_SCENARIO_EDIT_OWN], object.risk_scenario) && (!getClient.parent || (getClient.parent && object.risk_scenario.partition))"
                            @click="showActivityRiskScenarioDeleteModal(item)"
                    >
                      <font-awesome-icon icon="trash-alt" />
                    </button>
                    <span>
                      <Avatar :object="item.updated_by" size="xs" class="mr-2" v-if="item.updated_by"></Avatar>
                      {{ item.created_at | formatDate }}
                    </span>
                  </td>
                </tr>
                <tr v-if="businessRisks && !businessRisks.length" qid="activity-risk-scenario-no-results-row" class="text-center">
                  <td colspan="10">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <span class="text-light mt-2">
            * {{ $t('activities.risk_scenario.business_risk_tip') }}
          </span>
        </div>

        <!-- Privacy risk -->
        <div :class="{'col-sm-6': hasType('business_risk'), 'col-sm-12': !hasType('business_risk')}" v-if="hasType('privacy_risk')">
          <div class="mb-2" v-if="getClient.risk_type != 'cia_risk'">
            <span v-if="riskScenarioItem && riskScenarioItem.privacy_inherent_risk" class="mr-3">
              <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>:
              <span v-if="!riskScenarioItem.privacy_inherent_risk.risk">{{ $t('system.n_a') }}</span>
              <span :qid="'risk-risk-' + riskScenarioItem.privacy_inherent_risk.risk" v-if="riskScenarioItem.privacy_inherent_risk.risk">
                <font-awesome-icon
                  icon="exclamation-triangle"
                  v-if="riskScenarioItem.privacy_inherent_risk.number"
                  :class="[ riskScenarioItem.privacy_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_inherent_risk.number : 'risk' ]"
                />
                <span v-if="riskScenarioItem.privacy_inherent_risk.risk">
                  {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_inherent_risk.risk)) }}
                </span>
                <span v-if="riskScenarioItem.privacy_inherent_risk.number">
                  ({{riskScenarioItem.privacy_inherent_risk.number}})
                </span>
                &nbsp;
              </span>
            </span>
            <span class="mr-3">
              <span>{{ $t('activities.risk_scenario.inherent_risk.risk_tolerance_label') }}</span>:
              <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.privacy_risk_tolerance.risk)">{{ $t('system.n_a') }}</span>
              <span v-if="object.risk_category && object.risk_category.privacy_risk_tolerance.risk">
                <font-awesome-icon
                  icon="exclamation-triangle"
                  v-if="object.risk_category.privacy_risk_tolerance.number"
                  :class="[ object.risk_category.privacy_risk_tolerance.number ? 'risk-'+object.risk_category.privacy_risk_tolerance.number : 'risk' ]"
                />
                <span v-if="object.risk_category.privacy_risk_tolerance.risk">
                  {{ $t('risk.' + $options.filters.slugify(object.risk_category.privacy_risk_tolerance.risk)) }}
                </span>
                <span v-if="object.risk_category.privacy_risk_tolerance.number">
                  ({{object.risk_category.privacy_risk_tolerance.number}})
                </span>
                &nbsp;
              </span>
            </span>
          </div>
          <div class="mb-2 row" v-if="getClient.risk_type == 'cia_risk'">
            <div class="col-sm-6">
              <div>
                <div class="mb-2">
                  <span>{{ $t('activities.risk_scenario.inherent_risk.inherent_risk_label') }}</span>:
                </div>
                <div>
                  <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                  <span v-if="!riskScenarioItem.privacy_confidentiality_inherent_risk.risk">{{ $t('system.n_a') }}</span>
                  <span :qid="'risk-risk-' + riskScenarioItem.privacy_confidentiality_inherent_risk.risk" v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.risk">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.number"
                      :class="[ riskScenarioItem.privacy_confidentiality_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_confidentiality_inherent_risk.number : 'risk' ]"
                    />
                    <span v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.risk">
                      {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_confidentiality_inherent_risk.risk)) }}
                    </span>
                    <span v-if="riskScenarioItem.privacy_confidentiality_inherent_risk.number">
                      ({{riskScenarioItem.privacy_confidentiality_inherent_risk.number}})
                    </span>
                    &nbsp;
                  </span>
                </div>
                <div>
                  <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                  <span v-if="!riskScenarioItem.privacy_integrity_inherent_risk.risk">{{ $t('system.n_a') }}</span>
                  <span :qid="'risk-risk-' + riskScenarioItem.privacy_integrity_inherent_risk.risk" v-if="riskScenarioItem.privacy_integrity_inherent_risk.risk">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      v-if="riskScenarioItem.privacy_integrity_inherent_risk.number"
                      :class="[ riskScenarioItem.privacy_integrity_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_integrity_inherent_risk.number : 'risk' ]"
                    />
                    <span v-if="riskScenarioItem.privacy_integrity_inherent_risk.risk">
                      {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_integrity_inherent_risk.risk)) }}
                    </span>
                    <span v-if="riskScenarioItem.privacy_integrity_inherent_risk.number">
                      ({{riskScenarioItem.privacy_integrity_inherent_risk.number}})
                    </span>
                    &nbsp;
                  </span>
                </div>
                <div>
                  <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                  <span v-if="!riskScenarioItem.privacy_availability_inherent_risk.risk">{{ $t('system.n_a') }}</span>
                  <span :qid="'risk-risk-' + riskScenarioItem.privacy_availability_inherent_risk.risk" v-if="riskScenarioItem.privacy_availability_inherent_risk.risk">
                    <font-awesome-icon
                      icon="exclamation-triangle"
                      v-if="riskScenarioItem.privacy_availability_inherent_risk.number"
                      :class="[ riskScenarioItem.privacy_availability_inherent_risk.number ? 'risk-'+riskScenarioItem.privacy_availability_inherent_risk.number : 'risk' ]"
                    />
                    <span v-if="riskScenarioItem.privacy_availability_inherent_risk.risk">
                      {{ $t('risk.' + $options.filters.slugify(riskScenarioItem.privacy_availability_inherent_risk.risk)) }}
                    </span>
                    <span v-if="riskScenarioItem.privacy_availability_inherent_risk.number">
                      ({{riskScenarioItem.privacy_availability_inherent_risk.number}})
                    </span>
                    &nbsp;
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-2">
                <span>{{ $t('activities.risk_scenario.inherent_risk.risk_tolerance_label') }}</span>:
              </div>
              <div>
                <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.privacy_risk_confidentiality.risk)">{{ $t('system.n_a') }}</span>
                <span v-if="object.risk_category && object.risk_category.privacy_risk_confidentiality.risk">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                    v-if="object.risk_category.privacy_risk_confidentiality.number"
                    :class="[ object.risk_category.privacy_risk_confidentiality.number ? 'risk-'+object.risk_category.privacy_risk_confidentiality.number : 'risk' ]"
                  />
                  <span v-if="object.risk_category.privacy_risk_confidentiality.risk">
                    {{ $t('risk.' + $options.filters.slugify(object.risk_category.privacy_risk_confidentiality.risk)) }}
                  </span>
                  <span v-if="object.risk_category.privacy_risk_confidentiality.number">
                    ({{object.risk_category.privacy_risk_confidentiality.number}})
                  </span>
                  &nbsp;
                </span>
              </div>
              <div>
                <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.privacy_risk_integrity.risk)">{{ $t('system.n_a') }}</span>
                <span v-if="object.risk_category && object.risk_category.privacy_risk_integrity.risk">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                    v-if="object.risk_category.privacy_risk_integrity.number"
                    :class="[ object.risk_category.privacy_risk_integrity.number ? 'risk-'+object.risk_category.privacy_risk_integrity.number : 'risk' ]"
                  />
                  <span v-if="object.risk_category.privacy_risk_integrity.risk">
                    {{ $t('risk.' + $options.filters.slugify(object.risk_category.privacy_risk_integrity.risk)) }}
                  </span>
                  <span v-if="object.risk_category.privacy_risk_integrity.number">
                    ({{object.risk_category.privacy_risk_integrity.number}})
                  </span>
                  &nbsp;
                </span>
              </div>
              <div>
                <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                <span v-if="!object.risk_category || (object.risk_category && !object.risk_category.privacy_risk_availability.risk)">{{ $t('system.n_a') }}</span>
                <span v-if="object.risk_category && object.risk_category.privacy_risk_availability.risk">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                    v-if="object.risk_category.privacy_risk_availability.number"
                    :class="[ object.risk_category.privacy_risk_availability.number ? 'risk-'+object.risk_category.privacy_risk_availability.number : 'risk' ]"
                  />
                  <span v-if="object.risk_category.privacy_risk_availability.risk">
                    {{ $t('risk.' + $options.filters.slugify(object.risk_category.privacy_risk_availability.risk)) }}
                  </span>
                  <span v-if="object.risk_category.privacy_risk_availability.number">
                    ({{object.risk_category.privacy_risk_availability.number}})
                  </span>
                  &nbsp;
                </span>
              </div>
            </div>
          </div>
          <div class="form-control auto-height">


            <button class="btn btn-success btn-sm mt-3 float-right"
                    qid="add-privacy-risk-button"
                    v-if="
                      (
                        (riskScenarioItem.activity && riskScenarioItem.activity.active_client.slug == getClient.slug) ||
                        (riskScenarioItem.process && riskScenarioItem.process.active_client.slug == getClient.slug) ||
                        (riskScenarioItem.system && riskScenarioItem.system.active_client.slug == getClient.slug) ||
                        (riskScenarioItem.third_party && riskScenarioItem.third_party.active_client.slug == getClient.slug)
                      ) &&
                      (
                        (
                          (riskScenarioItem && riskScenarioItem.activity && isGranted([permissions.ACTIVITY_EDIT, permissions.ACTIVITY_EDIT_OWN], riskScenarioItem.activity)) ||
                          (riskScenarioItem && riskScenarioItem.process && isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], riskScenarioItem.process)) ||
                          (riskScenarioItem && riskScenarioItem.system && isGranted([permissions.SYSTEM_EDIT, permissions.PROCESS_EDIT_OWN], riskScenarioItem.system)) ||
                          (riskScenarioItem && riskScenarioItem.third_party && isGranted([permissions.THIRD_PARTY_EDIT, permissions.THIRD_PARTY_EDIT_OWN], riskScenarioItem.third_party))
                        ) ||
                        isGranted([permissions.RISK_SCENARIO_EDIT, permissions.RISK_SCENARIO_EDIT_OWN], riskScenarioItem.risk_scenario)
                      )
                    "
                    @click="showPrivacyRiskModal()"
            >
              {{ $t('activities.risk_scenario.current_risk.new_privacy_risk_button') }}
            </button>
            <h5 class="mt-3">{{ $t('activities.risk_scenario.inherent_risk.privacy_risk') }}</h5>
            <table class="table table-responsive-md table-sm">
              <thead>
              <tr>
                <th scope="col">
                  {{ $t('maintenance.risk_categories.risk.risk_label') }}
                </th>
                <th scope="col">
                  {{ $t('activities.risk_scenario.inherent_risk.risk_response_label') }}
                </th>
                <th scope="col">
                  {{ $t('system.last_updated') }}
                </th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in privacyRisks"
                    v-if="index == 0"
                    class="text-bold"
                >
                  <td v-if="item">
                    <div v-if="getClient.risk_type == 'cia_risk'" @click="showViewRiskModal(item)">
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                        <span :qid="'risk-risk-' + item.confidentiality_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.confidentiality_risk.number"
                              :class="[ item.confidentiality_risk.number ? 'risk-'+item.confidentiality_risk.number : 'risk' ]"
                          />
                          <span v-if="item.confidentiality_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.confidentiality_risk.risk)) }}
                          </span>
                          <span v-if="item.confidentiality_risk.number">
                            ({{item.confidentiality_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                        <span :qid="'risk-risk-' + item.integrity_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.integrity_risk.number"
                              :class="[ item.integrity_risk.number ? 'risk-'+item.integrity_risk.number : 'risk' ]"
                          />
                          <span v-if="item.integrity_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.integrity_risk.risk)) }}
                          </span>
                          <span v-if="item.integrity_risk.number">
                            ({{item.integrity_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                        <span :qid="'risk-risk-' + item.availability_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.availability_risk.number"
                              :class="[ item.availability_risk.number ? 'risk-'+item.availability_risk.number : 'risk' ]"
                          />
                          <span v-if="item.availability_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.availability_risk.risk)) }}
                          </span>
                          <span v-if="item.availability_risk.number">
                            ({{item.availability_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                    </div>
                    <span :qid="'risk-risk-' + item.risk.risk"
                          @click="showViewRiskModal(item)"
                          class="cursor-pointer"
                          v-if="getClient.risk_type != 'cia_risk'"
                    >
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="item.risk.number"
                          :class="[ item.risk.number ? 'risk-'+item.risk.number : 'risk' ]"
                      />
                      <span v-if="item.risk.risk">
                        {{ $t('risk.' + $options.filters.slugify(item.risk.risk)) }}
                      </span>
                      <span v-if="item.risk.number">
                        ({{item.risk.number}})
                      </span>
                      &nbsp;
                    </span>
                  </td>
                  <td v-if="item">
                    <span v-if="item.risk_response">
                      {{ $t('risk_response.' + $options.filters.slugify(item.risk_response)) }}
                    </span>
                  </td>
                  <td v-if="item">
                    <span>
                      <Avatar :object="item.updated_by" size="xs" class="mr-2" v-if="item.updated_by"></Avatar>
                      {{ item.created_at | formatDate }}
                    </span>
                  </td>
                </tr>
                <tr class="text-center" v-if="privacyRisks && privacyRisks.length && privacyRisks.length > 1">
                  <td colspan="6" class="text-center cursor-pointer" @click="privacyHistoryShow=!privacyHistoryShow">
                    <span class="mr-2">{{ $t('activities.risk_scenario.view_history_log') }}</span>
                    <font-awesome-icon icon="chevron-down" v-if="!privacyHistoryShow"/>
                    <font-awesome-icon icon="chevron-up" v-if="privacyHistoryShow"/>
                  </td>
                </tr>
                <tr v-for="(item, index) in privacyRisks"
                    v-if="index >= 1 && privacyHistoryShow"
                    class="text-bold"
                >
                  <td v-if="item">
                    <div v-if="getClient.risk_type == 'cia_risk'" @click="showViewRiskModal(item)">
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">C</span>
                        <span :qid="'risk-risk-' + item.confidentiality_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.confidentiality_risk.number"
                              :class="[ item.confidentiality_risk.number ? 'risk-'+item.confidentiality_risk.number : 'risk' ]"
                          />
                          <span v-if="item.confidentiality_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.confidentiality_risk.risk)) }}
                          </span>
                          <span v-if="item.confidentiality_risk.number">
                            ({{item.confidentiality_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">I</span>
                        <span :qid="'risk-risk-' + item.integrity_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.integrity_risk.number"
                              :class="[ item.integrity_risk.number ? 'risk-'+item.integrity_risk.number : 'risk' ]"
                          />
                          <span v-if="item.integrity_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.integrity_risk.risk)) }}
                          </span>
                          <span v-if="item.integrity_risk.number">
                            ({{item.integrity_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>
                      <div>
                        <span style="display: inline-block; width: 10px; margin-right: 10px; text-align: center">A</span>
                        <span :qid="'risk-risk-' + item.availability_risk.risk"
                              class="cursor-pointer"
                        >
                          <font-awesome-icon
                              icon="exclamation-triangle"
                              v-if="item.availability_risk.number"
                              :class="[ item.availability_risk.number ? 'risk-'+item.availability_risk.number : 'risk' ]"
                          />
                          <span v-if="item.availability_risk.risk">
                            {{ $t('risk.' + $options.filters.slugify(item.availability_risk.risk)) }}
                          </span>
                          <span v-if="item.availability_risk.number">
                            ({{item.availability_risk.number}})
                          </span>
                          &nbsp;
                        </span>
                      </div>

                    </div>
                    <span :qid="'risk-risk-' + item.risk.risk"
                          @click="showViewRiskModal(item)"
                          class="cursor-pointer"
                          v-if="getClient.risk_type != 'cia_risk'"
                    >
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          v-if="item.risk.number"
                          :class="[ item.risk.number ? 'risk-'+item.risk.number : 'risk' ]"
                      />
                      <span v-if="item.risk.risk">
                        {{ $t('risk.' + $options.filters.slugify(item.risk.risk)) }}
                      </span>
                      <span v-if="item.risk.number">
                        ({{item.risk.number}})
                      </span>
                      &nbsp;
                    </span>
                  </td>
                  <td v-if="item">
                    <span v-if="item.risk_response">
                      {{ $t('risk_response.' + $options.filters.slugify(item.risk_response)) }}
                    </span>
                  </td>
                  <td v-if="item">
                    <button class="text-muted float-right ml-2 btn btn-link btn-sm"
                            qid="delete-activity-privacy-risk-scenario-modal"
                            v-if="isGranted([permissions.RISK_SCENARIO_EDIT, permissions.RISK_SCENARIO_EDIT_OWN], object.risk_scenario) && (!getClient.parent || (getClient.parent && object.risk_scenario.partition))"
                            @click="showActivityRiskScenarioDeleteModal(item)"
                    >
                      <font-awesome-icon icon="trash-alt" />
                    </button>
                    <span>
                      <Avatar :object="item.updated_by" size="xs" class="mr-2" v-if="item.updated_by"></Avatar>
                      {{ item.created_at | formatDate }}
                    </span>
                  </td>
                </tr>
                <tr v-if="privacyRisks && !privacyRisks.length" qid="activity-risk-scenario-no-results-row" class="text-center">
                  <td colspan="10">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <span class="text-light mt-2">
            * {{ $t('activities.risk_scenario.privacy_risk_tip') }}
          </span>
        </div>
      </div>

      <div class="text-center mt-4 mb-4">
        <span class="cursor-pointer"
              @click="mitigationFactorsShow = !mitigationFactorsShow"
              qid="mitigations-factors-expand"
        >
          <span class="mr-2">{{ $t('activities.risk_scenario.view_mitigation_factors') }}</span>
          <font-awesome-icon icon="chevron-down" v-if="!mitigationFactorsShow"/>
          <font-awesome-icon icon="chevron-up" v-if="mitigationFactorsShow"/>
        </span>
      </div>

      <div v-if="mitigationFactorsShow">
        <MitigatingFactors :object="object" :activity="riskScenarioItem.activity" :riskScenarioItem="riskScenarioItem" v-if="riskScenarioItem.activity"></MitigatingFactors>
        <MitigatingFactors :object="object" :activity="riskScenarioItem.process" :riskScenarioItem="riskScenarioItem" v-if="riskScenarioItem.process"></MitigatingFactors>
        <MitigatingFactors :object="object" :activity="riskScenarioItem.system" :riskScenarioItem="riskScenarioItem" v-if="riskScenarioItem.system"></MitigatingFactors>
        <MitigatingFactors :object="object" :activity="riskScenarioItem.third_party" :riskScenarioItem="riskScenarioItem" v-if="riskScenarioItem.third_party"></MitigatingFactors>
      </div>

      <b-button class="mt-4 float-right"
                variant="success"
                @click="hideCurrentRiskModal"
                qid="cancel-button"
      >
        {{ $t('processes.policies.view.close') }}
      </b-button>

    </b-modal>


    <!-- New business risk modal -->
    <b-modal ref="new-business-risk" hide-footer @hide="hideBusinessRiskModal">
      <div class="d-block text-center">
        <h4 qid="business-risk-modal-title">
          {{ $t('activities.risk_scenario.current_risk.new_business_risk_label') }}
        </h4>
      </div>
      <b-alert v-if="newBusinessError.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ newBusinessError }}
      </b-alert>

      <b-form qid="create-business-risk-form">
        <div class="form-container">
          <div v-if="getClient.risk_type != 'cia_risk'">
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newBusinessImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newBusinessProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
          </div>
          <div v-if="getClient.risk_type == 'cia_risk'">

            <!--  Confidentiality-->

            <h5>{{ $t('validations.checklist.confidentiality') }}</h5>
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newBusinessConfidentialityImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_confidentiality_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newBusinessConfidentialityProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_confidentiality_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>

            <!-- Integrity -->

            <h5>{{ $t('validations.checklist.integrity') }}</h5>
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newBusinessIntegrityImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_integrity_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newBusinessIntegrityProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_integrity_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>

            <!-- Availability -->

            <h5>{{ $t('validations.checklist.availability') }}</h5>
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newBusinessAvailabilityImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_availability_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newBusinessAvailabilityProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('business_availability_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
          </div>
          <b-form-group>
            <label qid="create-risk-description-label">
              {{ $t('activities.risk_scenario.inherent_risk.description_label') }}
            </label>
            <b-form-textarea
              qid="risk-form-description"
              v-model="newBusinessDescription"
              rows="4"
              max-rows="4"
              :placeholder="$t('activities.risk_scenario.inherent_risk.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <p class="mt-2 mb-3" v-if="getClient.risk_type != 'cia_risk'">
            <span>{{ $t('activities.risk_scenario.current_risk.new_current_risk_label') }}:</span>
            <RealtimeRisk
                :impact="newBusinessImpact == null ? [] : newBusinessImpact"
                :probability="newBusinessProbability == null ? [] : newBusinessProbability"
                :riskTolerance="object.risk_category ? object.risk_category.business_risk_tolerance : []"
                :riskCategory="object.risk_category"
            ></RealtimeRisk>
          </p>
          <p v-if="getClient.risk_type == 'cia_risk'">
            <span>{{ $t('activities.risk_scenario.current_risk.new_current_risk_label') }}:</span>
            <RealtimeRiskCia
                :confidentialityImpact="newBusinessConfidentialityImpact == null ? [] : newBusinessConfidentialityImpact"
                :confidentialityProbability="newBusinessConfidentialityProbability == null ? [] : newBusinessConfidentialityProbability"
                :integrityImpact="newBusinessIntegrityImpact == null ? [] : newBusinessIntegrityImpact"
                :integrityProbability="newBusinessIntegrityProbability == null ? [] : newBusinessIntegrityProbability"
                :availabilityImpact="newBusinessAvailabilityImpact == null ? [] : newBusinessAvailabilityImpact"
                :availabilityProbability="newBusinessAvailabilityProbability == null ? [] : newBusinessAvailabilityProbability"
                :cTolerance="object.risk_category ? object.risk_category.business_risk_confidentiality : []"
                :iTolerance="object.risk_category ? object.risk_category.business_risk_integrity : []"
                :aTolerance="object.risk_category ? object.risk_category.business_risk_availability : []"
                :riskCategory="object.risk_category"
            ></RealtimeRiskCia>
          </p>
          <b-form-group>
            <label qid="create-risk-risk-response-label">
              {{ $t('activities.risk_scenario.inherent_risk.risk_response_label') }}
            </label>
            <multiselect
                v-model="riskResponse"
                :options="riskResponseItems"
                :placeholder="$t('activities.risk_scenario.inherent_risk.risk_response_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="form-risk-response"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-risk-risk-response-description-label">
              {{ $t('activities.risk_scenario.inherent_risk.risk_response_description_label') }}
            </label>
            <b-form-textarea
              qid="risk-form-risk-response-description"
              v-model="newRiskResponseDescription"
              rows="4"
              max-rows="4"
              :placeholder="$t('activities.risk_scenario.inherent_risk.risk_response_description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>

      <div class="text-right mt-3">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideBusinessRiskModal"
                  qid="risk-form-cancel-button"
        >
          {{ $t('processes.legal_basis.create.cancel') }}
        </b-button>
        <b-button class="mt-3 ml-3"
                  variant="success"
                  @click="newBusinessFormSubmit"
                  qid="risk-form-submit-button"
        >
          {{ $t('processes.legal_basis.create.submit') }}
        </b-button>
      </div>

    </b-modal>


    <!-- New privacy risk modal -->
    <b-modal ref="new-privacy-risk" hide-footer @hide="hidePrivacyRiskModal">
      <div class="d-block text-center">
        <h4 qid="new-privacy-risk-title">
          {{ $t('activities.risk_scenario.current_risk.new_privacy_risk_label') }}
        </h4>
      </div>
      <b-alert v-if="newPrivacyError.length"
               show
               variant="danger"
               qid="new-privacy-risk-error"
      >
        {{ newPrivacyError }}
      </b-alert>

      <b-form qid="new-privacy-risk-form">
        <div class="form-container">
          <div v-if="getClient.risk_type != 'cia_risk'">
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
          </div>
          <div v-if="getClient.risk_type == 'cia_risk'">

            <!--  Confidentiality-->

            <h5>{{ $t('validations.checklist.confidentiality') }}</h5>
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyConfidentialityImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_confidentiality_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyConfidentialityProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_confidentiality_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>

            <!-- Integrity -->

            <h5>{{ $t('validations.checklist.integrity') }}</h5>
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyIntegrityImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_integrity_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyIntegrityProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_integrity_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>

            <!-- Availability -->

            <h5>{{ $t('validations.checklist.availability') }}</h5>
            <b-form-group>
              <label qid="create-risk-impact-label">
                {{ $t('processes.risk.impact_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyAvailabilityImpact"
                  :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-impact"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_availability_impact')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
            <b-form-group>
              <label qid="create-risk-probability-label">
                {{ $t('processes.risk.probability_label') }}
              </label>
              <multiselect
                  v-model="newPrivacyAvailabilityProbability"
                  :options="probabilityItems"
                  :placeholder="$t('processes.risk.probability_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="form-probability"
              ></multiselect>
              <div class="text-right" v-if="object.risk_category && object.risk_category.id">
                <a @click="openViewDefinitionsModal('privacy_availability_probability')">
                  {{ $t('risk_scenarios.view_definitions_button') }}
                </a>
              </div>
            </b-form-group>
          </div>
          <b-form-group>
            <label qid="create-risk-description-label">
              {{ $t('activities.risk_scenario.inherent_risk.description_label') }}
            </label>
            <b-form-textarea
              qid="risk-form-description"
              v-model="newPrivacyDescription"
              rows="4"
              max-rows="4"
              :placeholder="$t('activities.risk_scenario.inherent_risk.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <p class="mt-2 mb-3" v-if="getClient.risk_type != 'cia_risk'">
            <span>{{ $t('activities.risk_scenario.current_risk.new_current_risk_label') }}:</span>
            <RealtimeRisk
                :impact="newPrivacyImpact == null ? [] : newPrivacyImpact"
                :probability="newPrivacyProbability == null ? [] : newPrivacyProbability"
                :riskTolerance="object.risk_category ? object.risk_category.privacy_risk_tolerance : []"
                :riskCategory="object.risk_category"
            ></RealtimeRisk>
          </p>
          <p v-if="getClient.risk_type == 'cia_risk'">
            <span>{{ $t('activities.risk_scenario.current_risk.new_current_risk_label') }}:</span>
            <RealtimeRiskCia
                :confidentialityImpact="newPrivacyConfidentialityImpact == null ? [] : newPrivacyConfidentialityImpact"
                :confidentialityProbability="newPrivacyConfidentialityProbability == null ? [] : newPrivacyConfidentialityProbability"
                :integrityImpact="newPrivacyIntegrityImpact == null ? [] : newPrivacyIntegrityImpact"
                :integrityProbability="newPrivacyIntegrityProbability == null ? [] : newPrivacyIntegrityProbability"
                :availabilityImpact="newPrivacyAvailabilityImpact == null ? [] : newPrivacyAvailabilityImpact"
                :availabilityProbability="newPrivacyAvailabilityProbability == null ? [] : newPrivacyAvailabilityProbability"
                :cTolerance="object.risk_category ? object.risk_category.privacy_risk_confidentiality : []"
                :iTolerance="object.risk_category ? object.risk_category.privacy_risk_integrity : []"
                :aTolerance="object.risk_category ? object.risk_category.privacy_risk_availability : []"
                :riskCategory="object.risk_category"
            ></RealtimeRiskCia>
          </p>
          <b-form-group>
            <label qid="create-risk-risk-response-label">
              {{ $t('activities.risk_scenario.inherent_risk.risk_response_label') }}
            </label>
            <multiselect
                v-model="riskResponse"
                :options="riskResponseItems"
                :placeholder="$t('activities.risk_scenario.inherent_risk.risk_response_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="form-probability"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-risk-risk-response-description-label">
              {{ $t('activities.risk_scenario.inherent_risk.risk_response_description_label') }}
            </label>
            <b-form-textarea
              qid="risk-form-risk-response-description"
              v-model="newRiskResponseDescription"
              rows="4"
              max-rows="4"
              :placeholder="$t('activities.risk_scenario.inherent_risk.risk_response_description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>

      <div class="text-right mt-3">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hidePrivacyRiskModal"
                  qid="risk-form-cancel-button"
        >
          {{ $t('processes.legal_basis.create.cancel') }}
        </b-button>
        <b-button class="mt-3 ml-3"
                  variant="success"
                  @click="newPrivacyFormSubmit"
                  qid="risk-form-submit-button"
        >
          {{ $t('processes.legal_basis.create.submit') }}
        </b-button>
      </div>

    </b-modal>


    <!-- View risk modal -->
    <b-modal ref="view-risk" hide-footer @hide="hideViewRiskModal">
      <div class="d-block text-center">
        <h4 qid="business-risk-title" v-if="selectedRisk && selectedRisk.type == 'business risk'">
          {{ $t('risk_scenarios.view_business_risk_label') }}
        </h4>
        <h4 qid="privacy-risk-title" v-if="selectedRisk && selectedRisk.type == 'privacy risk'">
          {{ $t('risk_scenarios.view_privacy_risk_label') }}
        </h4>
      </div>
      <div v-if="getClient.risk_type != 'cia_risk'">
        <label class="mt-3" v-if="selectedRisk && selectedRisk.impact">
          {{ $t('activities.risk_scenario.current_risk.table.impact') }}
        </label>
        <br>
        <span>{{ selectedRisk.impact }}</span>
        <br>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.probability">
          {{ $t('activities.risk_scenario.current_risk.table.probability') }}
        </label>
        <br>
        <span>{{ selectedRisk.probability }}</span>
        <br>
      </div>
      <div v-if="getClient.risk_type == 'cia_risk'">
        <h6 class="mt-4 mb-0">{{ $t('validations.checklist.confidentiality') }}</h6>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.confidentiality_impact">
          {{ $t('activities.risk_scenario.current_risk.table.impact') }}
        </label>
        <br>
        <span>{{ selectedRisk.confidentiality_impact }}</span>
        <br>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.confidentiality_probability">
          {{ $t('activities.risk_scenario.current_risk.table.probability') }}
        </label>
        <br>
        <span>{{ selectedRisk.confidentiality_probability }}</span>
        <br>

        <h6 class="mt-4 mb-0">{{ $t('validations.checklist.integrity') }}</h6>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.integrity_impact">
          {{ $t('activities.risk_scenario.current_risk.table.impact') }}
        </label>
        <br>
        <span>{{ selectedRisk.integrity_impact }}</span>
        <br>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.integrity_probability">
          {{ $t('activities.risk_scenario.current_risk.table.probability') }}
        </label>
        <br>
        <span>{{ selectedRisk.integrity_probability }}</span>
        <br>

        <h6 class="mt-4 mb-0">{{ $t('validations.checklist.availability') }}</h6>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.availability_impact">
          {{ $t('activities.risk_scenario.current_risk.table.impact') }}
        </label>
        <br>
        <span>{{ selectedRisk.availability_impact }}</span>
        <br>
        <label class="mt-3" v-if="selectedRisk && selectedRisk.availability_probability">
          {{ $t('activities.risk_scenario.current_risk.table.probability') }}
        </label>
        <br>
        <span>{{ selectedRisk.availability_probability }}</span>
        <br>

      </div>
      <label class="mt-3" v-if="selectedRisk.description">
        {{ $t('systems.create.description_label') }}
      </label>
      <br>
      <div v-if="selectedRisk.description && selectedRisk.description.length > 300">
        <p v-if="showFullDescription" class="text-formatted">
          {{ selectedRisk.description }}
        </p>
        <p v-if="!showFullDescription" class="text-formatted">
          {{ selectedRisk.description | truncate(300) }}
        </p>
        <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
          <span class="cursor-pointer" v-if="!showFullDescription">
            <span class="mr-2">
              {{ $t('system.view_more') }}
            </span>
            <font-awesome-icon icon="chevron-down"/>
          </span>
          <span class="cursor-pointer" v-if="showFullDescription">
            <span class="mr-2">
              {{ $t('system.view_less') }}
            </span>
            <font-awesome-icon icon="chevron-up"/>
          </span>
        </div>
      </div>
      <p v-if="selectedRisk.description && selectedRisk.description.length <= 300"
         class="text-formatted"
      >
        {{ selectedRisk.description }}
      </p>
      <br>
      <label class="mt-3" v-if="selectedRisk && selectedRisk.risk_response">
        {{ $t('activities.risk_scenario.inherent_risk.risk_response_label') }}
      </label>
      <br>
      <span v-if="selectedRisk && selectedRisk.risk_response">
        {{ $t('risk_response.' + $options.filters.slugify(selectedRisk.risk_response)) }}
      </span>
      <br>
      <label class="mt-3" v-if="selectedRisk.risk_response_description">
        {{ $t('activities.risk_scenario.inherent_risk.risk_response_description_label') }}
      </label>
      <br>
      <div v-if="selectedRisk.risk_response_description && selectedRisk.risk_response_description.length > 300">
        <p v-if="showFullRiskResponseDescription" class="text-formatted">
          {{ selectedRisk.risk_response_description }}
        </p>
        <p v-if="!showFullRiskResponseDescription" class="text-formatted">
          {{ selectedRisk.risk_response_description | truncate(300) }}
        </p>
        <div class="text-center mt-3" @click="showFullRiskResponseDescription=!showFullRiskResponseDescription">
          <span class="cursor-pointer" v-if="!showFullRiskResponseDescription">
            <span class="mr-2">
              {{ $t('system.view_more') }}
            </span>
            <font-awesome-icon icon="chevron-down"/>
          </span>
          <span class="cursor-pointer" v-if="showFullRiskResponseDescription">
            <span class="mr-2">
              {{ $t('system.view_less') }}
            </span>
            <font-awesome-icon icon="chevron-up"/>
          </span>
        </div>
      </div>
      <p v-if="selectedRisk.risk_response_description && selectedRisk.risk_response_description.length <= 300"
         class="text-formatted"
      >
        {{ selectedRisk.risk_response_description }}
      </p>
      <br>
      <div>
        <b-button class="mt-4 mb-4 float-right"
                  variant="success"
                  @click="hideViewRiskModal"
                  qid="view-risk-cancel-button"
        >
          {{ $t('processes.policies.view.close') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Delete risk scenario modal template -->
    <b-modal ref="delete-activity-risk" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-risk-title">
          {{ $t('activities.risk_scenario.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.risk_scenario.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideActivityRiskScenarioDeleteModal"
                  qid="delete-risk-cancel-button"
        >
          {{ $t('activities.risk_scenario.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteActivityRisk(riskToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-risk-submit-button"
        >
          {{ $t('activities.risk_scenario.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <ViewDefinitions
        :showModal="showViewDefinitionsModal"
        :type="definitionType"
        :object="object"
        @closeViewModal="handleCloseViewDefinitionsModal"
    ></ViewDefinitions>

    <PartitionNoticeModal
        :item="selectedItem"
        state="activities.view"
        :show="showNoticeModal"
        @closeViewModal="closeNoticeModal"
    ></PartitionNoticeModal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import PolicyViewModal from '@/views/Processes/PolicyViewModal.vue';
  import MitigatingFactors from '@/views/Activities/MitigatingFactors.vue';
  import ViewDefinitions from '@/views/RiskScenarios/ViewDefinitionsModal.vue';
  import RealtimeRisk from '@/views/RiskScenarios/RealtimeRisk.vue';
  import RealtimeRiskCia from '@/views/RiskScenarios/RealtimeRiskCia.vue';
  import PartitionNoticeModal from '@/components/PartitionNoticeModal.vue';

  export default {
    name: 'ResidualRiskModal',
    data: function() {
      return {
        error: '',
        loadingItems: false,
        itemToDelete: {},
        buttonDisabled: false,
        projectTemplateTableItems: [],
        projectTemplatesLoading: true,
        projectTemplateLoading: true,
        showPolicyDescription: false,
        selectedPolicy: [],
        viewPolicyModal: false,
        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        keywordValue: '',
        selectedSort: '',
        selectedDirection: '',

        showFullDescription: false,
        showFullRiskResponseDescription: false,

        impactItems: [
          { name: this.$t('impact.very_low'), value: 'Very low' },
          { name: this.$t('impact.low'), value: 'Low' },
          { name: this.$t('impact.high'), value: 'High' },
          { name: this.$t('impact.very_high'), value: 'Very high' }
        ],
        probabilityItems: [
          { name: this.$t('probability.very_unlikely'), value: 'Very unlikely' },
          { name: this.$t('probability.unlikely'), value: 'Unlikely' },
          { name: this.$t('probability.likely'), value: 'Likely' },
          { name: this.$t('probability.very_likely'), value: 'Very likely' }
        ],
        riskResponseItems: [
          { name: this.$t('risk_response.accept'), value: 'Accept' },
          { name: this.$t('risk_response.avoid'), value: 'Avoid' },
          { name: this.$t('risk_response.control'), value: 'Control' },
          { name: this.$t('risk_response.monitor'), value: 'Monitor' },
          { name: this.$t('risk_response.transfer'), value: 'Transfer' },
        ],

        riskResponse: [],
        newRiskResponseDescription: '',
        riskScenarioItem: {},
        privacyRisks: [],
        businessRisks: [],

        newBusinessImpact: [],
        newBusinessProbability: [],

        newBusinessConfidentialityImpact: [],
        newBusinessConfidentialityProbability: [],
        newBusinessIntegrityImpact: [],
        newBusinessIntegrityProbability: [],
        newBusinessAvailabilityImpact: [],
        newBusinessAvailabilityProbability: [],

        newPrivacyConfidentialityImpact: [],
        newPrivacyConfidentialityProbability: [],
        newPrivacyIntegrityImpact: [],
        newPrivacyIntegrityProbability: [],
        newPrivacyAvailabilityImpact: [],
        newPrivacyAvailabilityProbability: [],

        newBusinessDescription: '',
        newPrivacyImpact: [],
        newPrivacyProbability: [],
        newPrivacyDescription: '',
        businessHistoryShow: false,
        privacyHistoryShow: false,
        riskToDelete: {},
        riskThreatsItems: [],
        riskVulnerabilitiesItems: [],
        selectedRisk: {},
        dataTypes: [],
        validations: [],
        mitigationFactorsShow: false,
        newBusinessError: '',
        newPrivacyError: '',
        showViewDefinitionsModal: false,
        definitionType: '',
        showNoticeModal: false,
        selectedItem: {}
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      show: Boolean
    },
    components: {
      Avatar,
      PolicyViewModal,
      MitigatingFactors,
      ViewDefinitions,
      RealtimeRisk,
      RealtimeRiskCia,
      PartitionNoticeModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if (selectedTo > selectedOf) {
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      },
      // Watch when prop changes
      show: function (value) {
        if (value) {
          this.showCurrentRiskModal(this.object)
        }
      }
    },
    methods: {
      hasType(type, object) {
        let self = this;
        let found = false
        if (object) {
          if (object.risk_types && object.risk_types.length) {
            _.find(object.risk_types, function(item) {
              if (item == type) {
                found = true;
              }
            });
          }
        } else {
          if (this.riskScenarioItem && this.riskScenarioItem.risk_scenario) {
            if (this.riskScenarioItem.risk_scenario.risk_types && this.riskScenarioItem.risk_scenario.risk_types.length) {
              _.find(this.riskScenarioItem.risk_scenario.risk_types, function(item) {
                if (item == type) {
                  found = true;
                }
              });
            }
          }
        }
        return found
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      openNoticeModal(object) {
        this.selectedItem = object
        this.showNoticeModal = true
      },
      closeNoticeModal() {
        this.selectedItem = {}
        this.showNoticeModal = false
      },
      openViewDefinitionsModal(type) {
        this.definitionType = type
        this.showViewDefinitionsModal = true
      },
      handleCloseViewDefinitionsModal () {
        this.definitionType = ''
        this.showViewDefinitionsModal = false;
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users && users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
        return reducedUsers;
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      closeViewModal () {
        this.viewDDModal = false;
        this.selectedDD = []
      },
      openViewModal(object) {
        this.selectedDD = object
        this.viewDDModal = true
      },
      showCurrentRiskModal(object) {
        this.riskScenarioItem = object;
        this.loadPrivacyRisks()
        this.loadBusinessRisks()
        this.$refs['current-risk'].show()
      },
      hideCurrentRiskModal() {
        this.riskScenarioItem = {}
        this.error = ''
        this.$emit('closeResidualModal');
        this.$refs['current-risk'].hide()
      },
      loadBusinessRisks() {
        let self = this;
        let url = ''
        if (this.riskScenarioItem && this.riskScenarioItem.activity) {
          url = 'activities/' + this.riskScenarioItem.activity.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.process) {
          url = 'processes/' + this.riskScenarioItem.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.system) {
          url = 'systems/' + this.riskScenarioItem.system.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.third_party) {
          url = 'third-parties/' + this.riskScenarioItem.third_party.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        piincHttp.get(url, { params:
          {
            client: this.getClient.slug,
            type: 'business risk'
          }
        }).then(function(response) {
          self.businessRisks = []
          _.forEach(response.data, function (item) {
            if (self.getClient.risk_type == item.risk_type) {
              self.businessRisks.push(item)
            }
          })
          self.rrLoading = false;
        }, function() {});
      },
      loadPrivacyRisks() {
        let self = this;
        let url = ''
        if (this.riskScenarioItem && this.riskScenarioItem.activity) {
          url = 'activities/' + this.riskScenarioItem.activity.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.process) {
          url = 'processes/' + this.riskScenarioItem.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.system) {
          url = 'systems/' + this.riskScenarioItem.system.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.third_party) {
          url = 'third-parties/' + this.riskScenarioItem.third_party.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        piincHttp.get(url, { params:
          {
            client: this.getClient.slug,
            type: 'privacy risk'
          }
        }).then(function(response) {
          self.privacyRisks = []
          _.forEach(response.data, function (item) {
            if (self.getClient.risk_type == item.risk_type) {
              self.privacyRisks.push(item)
            }
          })
          self.rrLoading = false;
        }, function() {});
      },
      newBusinessFormSubmit() {
        let url = ''
        if (this.riskScenarioItem && this.riskScenarioItem.activity) {
          url = 'activities/' + this.riskScenarioItem.activity.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.process) {
          url = 'processes/' + this.riskScenarioItem.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.system) {
          url = 'systems/' + this.riskScenarioItem.system.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.third_party) {
          url = 'third-parties/' + this.riskScenarioItem.third_party.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }

        this.newBusinessError = ''
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        formData.append("type", "business risk");
        formData.append("description", this.newBusinessDescription);
        formData.append("risk_response_description", this.newRiskResponseDescription);

        if (this.riskResponse && this.riskResponse.value) {
          formData.append("risk_response", this.riskResponse.value);
        }

        if (this.newBusinessImpact && this.newBusinessImpact.value) {
          formData.append("impact", this.newBusinessImpact.value);
        }

        if (this.newBusinessProbability && this.newBusinessProbability.value) {
          formData.append("probability", this.newBusinessProbability.value);
        }

        // Confidentiality
        if (this.newBusinessConfidentialityImpact && this.newBusinessConfidentialityImpact.value) {
          formData.append("confidentiality_impact", this.newBusinessConfidentialityImpact.value);
        }

        if (this.newBusinessConfidentialityProbability && this.newBusinessConfidentialityProbability.value) {
          formData.append("confidentiality_probability", this.newBusinessConfidentialityProbability.value);
        }


        // Integrity
        if (this.newBusinessIntegrityImpact && this.newBusinessIntegrityImpact.value) {
          formData.append("integrity_impact", this.newBusinessIntegrityImpact.value);
        }

        if (this.newBusinessIntegrityProbability && this.newBusinessIntegrityProbability.value) {
          formData.append("integrity_probability", this.newBusinessIntegrityProbability.value);
        }


        // Availability
        if (this.newBusinessAvailabilityImpact && this.newBusinessAvailabilityImpact.value) {
          formData.append("availability_impact", this.newBusinessAvailabilityImpact.value);
        }

        if (this.newBusinessAvailabilityProbability && this.newBusinessAvailabilityProbability.value) {
          formData.append("availability_probability", this.newBusinessAvailabilityProbability.value);
        }

        if (this.getClient.risk_type == "cia_risk") {
          if (
            this.newBusinessConfidentialityImpact && this.newBusinessConfidentialityImpact.value && this.newBusinessConfidentialityProbability && this.newBusinessConfidentialityProbability.value &&
            this.newBusinessIntegrityImpact && this.newBusinessIntegrityImpact.value && this.newBusinessIntegrityProbability && this.newBusinessIntegrityProbability.value &&
            this.newBusinessAvailabilityImpact && this.newBusinessAvailabilityImpact.value && this.newBusinessAvailabilityProbability && this.newBusinessAvailabilityProbability.value &&
            this.riskResponse && this.riskResponse.value
          ) {
            piincHttp.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('activities.risk_scenario.business_risk.success'))
              self.hideBusinessRiskModal();
              self.loadBusinessRisks();
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            if (
              (this.newBusinessConfidentialityImpact && !this.newBusinessConfidentialityImpact.value) ||
              (this.newBusinessIntegrityImpact && !this.newBusinessIntegrityImpact.value) ||
              (this.newBusinessAvailabilityImpact && !this.newBusinessAvailabilityImpact.value) ||
              (this.newBusinessConfidentialityProbability && !this.newBusinessConfidentialityProbability.value) ||
              (this.newBusinessIntegrityProbability && !this.newBusinessIntegrityProbability.value) ||
              (this.newBusinessAvailabilityProbability && !this.newBusinessAvailabilityProbability.value) ||
              this.newBusinessConfidentialityImpact == null || this.newBusinessIntegrityImpact == null || this.newBusinessAvailabilityImpact == null || this.newBusinessConfidentialityProbability == null || this.newBusinessIntegrityProbability == null || this.newBusinessAvailabilityProbability == null
            ) {
              this.newBusinessError += ' ' + this.$t('activities.risk_scenario.business_risk.all_fields_error')
            }
            if ((this.riskResponse && !this.riskResponse.value) || this.riskResponse == null) {
              this.newBusinessError += ' ' + this.$t('activities.risk_scenario.business_risk.risk_response_error')
            }
          }

        } else {
          if (this.newBusinessImpact && this.newBusinessImpact.value && this.newBusinessProbability && this.newBusinessProbability.value && this.riskResponse && this.riskResponse.value) {
            piincHttp.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('activities.risk_scenario.business_risk.success'))
              self.hideBusinessRiskModal();
              self.loadBusinessRisks();
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            if ((this.newBusinessImpact && !this.newBusinessImpact.value) || this.newBusinessImpact == null) {
              this.newBusinessError += this.$t('activities.risk_scenario.business_risk.impact_error')
            }
            if ((this.newBusinessProbability && !this.newBusinessProbability.value) || this.newBusinessProbability == null) {
              this.newBusinessError += ' ' + this.$t('activities.risk_scenario.business_risk.probability_error')
            }
            if ((this.riskResponse && !this.riskResponse.value) || this.riskResponse == null) {
              this.newBusinessError += ' ' + this.$t('activities.risk_scenario.business_risk.risk_response_error')
            }
          }
        }

      },
      newPrivacyFormSubmit() {
        let url = ''
        if (this.riskScenarioItem && this.riskScenarioItem.activity) {
          url = 'activities/' + this.riskScenarioItem.activity.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.process) {
          url = 'processes/' + this.riskScenarioItem.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.system) {
          url = 'systems/' + this.riskScenarioItem.system.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.third_party) {
          url = 'third-parties/' + this.riskScenarioItem.third_party.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks'
        }
        this.newPrivacyError = ''
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        formData.append("type", "privacy risk");
        formData.append("description", this.newPrivacyDescription);

        formData.append("risk_response_description", this.newRiskResponseDescription);

        if (this.riskResponse && this.riskResponse.value) {
          formData.append("risk_response", this.riskResponse.value);
        }

        if (this.newPrivacyImpact && this.newPrivacyImpact.value) {
          formData.append("impact", this.newPrivacyImpact.value);
        }

        if (this.newPrivacyProbability && this.newPrivacyProbability.value) {
          formData.append("probability", this.newPrivacyProbability.value);
        }

        // Confidentiality
        if (this.newPrivacyConfidentialityImpact && this.newPrivacyConfidentialityImpact.value) {
          formData.append("confidentiality_impact", this.newPrivacyConfidentialityImpact.value);
        }

        if (this.newPrivacyConfidentialityProbability && this.newPrivacyConfidentialityProbability.value) {
          formData.append("confidentiality_probability", this.newPrivacyConfidentialityProbability.value);
        }


        // Integrity
        if (this.newPrivacyIntegrityImpact && this.newPrivacyIntegrityImpact.value) {
          formData.append("integrity_impact", this.newPrivacyIntegrityImpact.value);
        }

        if (this.newPrivacyIntegrityProbability && this.newPrivacyIntegrityProbability.value) {
          formData.append("integrity_probability", this.newPrivacyIntegrityProbability.value);
        }


        // Availability
        if (this.newPrivacyAvailabilityImpact && this.newPrivacyAvailabilityImpact.value) {
          formData.append("availability_impact", this.newPrivacyAvailabilityImpact.value);
        }

        if (this.newPrivacyAvailabilityProbability && this.newPrivacyAvailabilityProbability.value) {
          formData.append("availability_probability", this.newPrivacyAvailabilityProbability.value);
        }

        if (this.getClient.risk_type == "cia_risk") {
          if (
            this.newPrivacyConfidentialityImpact && this.newPrivacyConfidentialityImpact.value && this.newPrivacyConfidentialityProbability && this.newPrivacyConfidentialityProbability.value &&
            this.newPrivacyIntegrityImpact && this.newPrivacyIntegrityImpact.value && this.newPrivacyIntegrityProbability && this.newPrivacyIntegrityProbability.value &&
            this.newPrivacyAvailabilityImpact && this.newPrivacyAvailabilityImpact.value && this.newPrivacyAvailabilityProbability && this.newPrivacyAvailabilityProbability.value &&
            this.riskResponse && this.riskResponse.value
          ) {
            piincHttp.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('activities.risk_scenario.privacy_risk.success'))
              self.hidePrivacyRiskModal();
              self.loadPrivacyRisks();
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            if (
              (this.newPrivacyConfidentialityImpact && !this.newPrivacyConfidentialityImpact.value) ||
              (this.newPrivacyIntegrityImpact && !this.newPrivacyIntegrityImpact.value) ||
              (this.newPrivacyAvailabilityImpact && !this.newPrivacyAvailabilityImpact.value) ||
              (this.newPrivacyConfidentialityProbability && !this.newPrivacyConfidentialityProbability.value) ||
              (this.newPrivacyIntegrityProbability && !this.newPrivacyIntegrityProbability.value) ||
              (this.newPrivacyAvailabilityProbability && !this.newPrivacyAvailabilityProbability.value) ||
              this.newPrivacyConfidentialityImpact == null || this.newPrivacyIntegrityImpact == null || this.newPrivacyAvailabilityImpact == null || this.newPrivacyConfidentialityProbability == null || this.newPrivacyIntegrityProbability == null || this.newPrivacyAvailabilityProbability == null
            ) {
              this.newPrivacyError += ' ' + this.$t('activities.risk_scenario.business_risk.all_fields_error')
            }
            if ((this.riskResponse && !this.riskResponse.value) || this.riskResponse == null) {
              this.newPrivacyError += ' ' + this.$t('activities.risk_scenario.business_risk.risk_response_error')
            }
          }

        } else {
          if (this.newPrivacyImpact && this.newPrivacyImpact.value && this.newPrivacyProbability && this.newPrivacyProbability.value && this.riskResponse && this.riskResponse.value) {
            piincHttp.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('activities.risk_scenario.privacy_risk.success'))
              self.hidePrivacyRiskModal();
              self.loadPrivacyRisks();
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            if ((this.newPrivacyImpact && !this.newPrivacyImpact.value) || this.newPrivacyImpact == null) {
              this.newPrivacyError += this.$t('activities.risk_scenario.privacy_risk.impact_error')
            }
            if ((this.newPrivacyProbability && !this.newPrivacyProbability.value) || this.newPrivacyProbability == null) {
              this.newPrivacyError += ' ' + this.$t('activities.risk_scenario.privacy_risk.probability_error')
            }
            if ((this.riskResponse && !this.riskResponse.value) || this.riskResponse == null) {
              this.newPrivacyError += ' ' + this.$t('activities.risk_scenario.business_risk.risk_response_error')
            }
          }
        }

      },
      showBusinessRiskModal() {
        this.newBusinessError = ''
        this.newBusinessImpact = []
        this.newBusinessProbability = []

        this.newBusinessConfidentialityImpact = []
        this.newBusinessConfidentialityProbability = []
        this.newBusinessIntegrityImpact = []
        this.newBusinessIntegrityProbability = []
        this.newBusinessAvailabilityImpact = []
        this.newBusinessAvailabilityProbability = []

        this.newBusinessDescription = ''
        this.riskResponse = []
        this.newRiskResponseDescription = ''
        this.$refs['new-business-risk'].show()
      },
      hideBusinessRiskModal() {
        this.$refs['new-business-risk'].hide()
      },
      showPrivacyRiskModal() {
        this.newPrivacyError = ''
        this.newPrivacyImpact = []
        this.newPrivacyProbability = []

        this.newPrivacyConfidentialityImpact = []
        this.newPrivacyConfidentialityProbability = []
        this.newPrivacyIntegrityImpact = []
        this.newPrivacyIntegrityProbability = []
        this.newPrivacyAvailabilityImpact = []
        this.newPrivacyAvailabilityProbability = []

        this.newPrivacyDescription = ''
        this.riskResponse = []
        this.newRiskResponseDescription = ''
        this.$refs['new-privacy-risk'].show()
      },
      hidePrivacyRiskModal() {
        this.$refs['new-privacy-risk'].hide()
      },
      loadRiskVulnerabilities(reset) {
        if (reset) {
          this.page = 1
          this.showMore = true;
          this.riskVulnerabilitiesItems = []
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.riskScenarioItem.risk_scenario.slug + '/vulnerabilities', { params:
          {
            client: this.getClient.slug,
            page: this.page
          }
        }).then(function(response) {
          self.page += 1;
          self.loading = false;
          if (response.data.items && response.data.items.length < 10) {
            self.showMore = false;
          }

          self.riskVulnerabilitiesItems.push(...response.data.items)

        }, function() {});
      },
      loadRiskThreats(reset) {
        if (reset) {
          this.page = 1
          this.showMore = true;
          this.riskThreatsItems = []
        }
        let self = this;
        piincHttp.get('risk-scenarios/' + this.riskScenarioItem.risk_scenario.slug + '/threats', { params:
          {
            client: this.getClient.slug,
            page: this.page
          }
        }).then(function(response) {
          self.page += 1;
          self.loading = false;
          if (response.data.items && response.data.items.length < 10) {
            self.showMore = false;
          }

          self.riskThreatsItems.push(...response.data.items)

        }, function() {});
      },
      showViewRiskModal(object) {
        this.selectedRisk = object;
        this.$refs['view-risk'].show()
      },
      hideViewRiskModal() {
        this.selectedRisk = {}
        this.$refs['view-risk'].hide()
      },
      showActivityRiskScenarioDeleteModal(object) {
        this.riskToDelete = object
        this.$refs['delete-activity-risk'].show()
      },
      hideActivityRiskScenarioDeleteModal() {
        this.riskToDelete = {}
        this.$refs['delete-activity-risk'].hide()
      },
      confirmDeleteActivityRisk(object) {
        let self = this;
        let url = ''
        if (this.riskScenarioItem && this.riskScenarioItem.activity) {
          url = 'activities/' + this.riskScenarioItem.activity.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks/'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.process) {
          url = 'processes/' + this.riskScenarioItem.process.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks/'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.system) {
          url = 'systems/' + this.riskScenarioItem.system.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks/'
        }
        if (this.riskScenarioItem && this.riskScenarioItem.third_party) {
          url = 'third-parties/' + this.riskScenarioItem.third_party.slug + '/risk-scenarios/' + this.riskScenarioItem.id + '/risks/'
        }
        piincHttp.delete(url + object.id).then(function() {
          self.hideActivityRiskScenarioDeleteModal();
          self.loadBusinessRisks();
          self.loadPrivacyRisks();
          // Trigger toastr message after modal close
          if (object.type == 'business risk') {
            self.$toastr('success', self.$t('activities.risk_scenario.delete.business_success'))
          } else {
            self.$toastr('success', self.$t('activities.risk_scenario.delete.privacy_success'))
          }
        }, function() {});
      },
    },
    created () {
      if (this.getClient && this.getClient.slug) {

      }
      this.riskScenarioItem = this.object;
    }
  }
</script>
